export default __webpack_public_path__ + "static/quote-7-cf906d3b2eafc6177d970d466c15a848.mp3";